var _path, _path2, _path3, _path4, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCommission(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84743 10.5179C5.2473 7.91869 7.48375 6 10.1135 6C12.7433 6 14.9797 7.91869 15.3796 10.5179L16.2649 16.2719C16.4047 17.1806 15.7016 18 14.7823 18H5.44475C4.52542 18 3.8224 17.1806 3.96219 16.2719L4.84743 10.5179Z",
    stroke: "#08827A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.11353 6.5L7.83713 3.94721C7.50468 3.28231 7.98818 2.5 8.73156 2.5H11.4955C12.2389 2.5 12.7224 3.28231 12.3899 3.94721L11.1135 6.5",
    stroke: "#08827A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11353 6H13.1135",
    stroke: "#08827A",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11353 14.5L12.1135 10.5",
    stroke: "#08827A",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.61353,
    cy: 11,
    r: 0.5,
    fill: "#08827A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.6135,
    cy: 14,
    r: 0.5,
    fill: "#08827A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCommission);
export default __webpack_public_path__ + "static/media/ic_commission.d0edc42c96b861ddae519ad307051359.svg";
export { ForwardRef as ReactComponent };